import React, { useState, useRef, useEffect } from 'react'
import { VerticalScrollBar } from '.'
import SearchBar from './SearchBar'
import { red_info } from '../../../assets/images'
import DSIcon from './DSIcon'

const SingleSelectInput = (
  { 
    name = '', 
    data = [''], 
    dataList=[],
    values = [], 
    labelTag='', 
    labelTagClasses = '',
    placeholder = 'Select', 
    label = '', 
    value = '', 
    position = 'bottom', 
    bgColor='bg-gray-100', 
    labelClasses = 'text-gray-700',
    dropdownDownArrowHeight = '350px',
    placeholderClasses= !value && 'text-gray-300',
    selectClasses = 'p-4', 
    listClasses = '', 
    listItemClasses = 'p-6 pb-5',
    errorClasses= '', 
    classes = '', 
    error = '', 
    id = '', 
    border = '' ,
    inputBoxClass='', 
    lineHeight='', 
    disable= false, 
    onChangeHandler = () => {}, 
    showErrorIcon = false,
    search = false,
    src= [],
    OnBlurHandler = () => {}
  }) => {
  const [open, setOpen] = useState(false)
  const selectRef = useRef()
  const btnRef = useRef()
  const searchRef =useRef()
  let [searchTerm, setSearchTerm] = useState('');
  let [filteredData, setFilteredData] = useState(data); 
  const handler = (value) => {
    setOpen(false)
    setSearchTerm('')
    setFilteredData(data)
    if(!value) return
    onChangeHandler({name, value},id)
  }

  useEffect(() => {
    const handler = (event) => {
      if (!(event.target === searchRef.current)) return
      else if(!(event.target === selectRef.current || event.target === btnRef.current)) setOpen(false)
    }
    document.body.addEventListener('click', handler)
    return () => document.body.removeEventListener('click', handler)
  }, [])

  const valuesLen = values.length
  
  
  const searchHandler= (searchTerm) => {
    setSearchTerm(searchTerm);
    filteredData = data.filter(item => item.toLowerCase().includes(searchTerm.toLowerCase()));
    setFilteredData(filteredData);
  }
  return (
    <>
      <div className={`relative ${classes}`}>
        {label && <label className={`font-semibold ${labelTag ? 'mb-1': 'mb-1'} block ${labelClasses}`}>{label}</label>}
        {labelTag && <label className={`mb-3 block ${labelTagClasses ? labelTagClasses : labelClasses}`}>{labelTag}</label>}

        <button 
          ref={btnRef}
          type="button" 
          disabled={disable}
          onClick={() => setOpen(val => !val)}
          className={`${bgColor} ${selectClasses} relative flex min-h-[44px] w-full items-center rounded-[10px] ${border ? border : 'border'} border-gray-300 text-left transition-colors duration-150 ${disable ? 'cursor-not-allowed opacity-70' : 'cursor-pointer hover:border-gray-400'} focus:outline-none ${inputBoxClass}`}
        >
          <input 
            ref={selectRef} 
            name={name} 
            value={value ? value : placeholder} 
            readOnly
            className={`${bgColor} ${placeholderClasses} block w-full cursor-pointer bg-transparent pr-8 text-[13px] font-medium text-gray-700 focus:outline-none ${lineHeight}`}
            onBlur={OnBlurHandler}
          />
          <span className="pointer-events-none absolute inset-y-0 right-4 flex items-center text-gray-500">
            {src.length > 0 ? (
              <img src={open ? src[0] : src[1]} alt='dropdown-icon' className='h-3 w-3' />
            ) : (
              <DSIcon name={open ? 'chevron-up' : 'chevron-down'} size={16} />
            )}
          </span>
        </button>

        <ul
          className={`${listClasses} absolute z-10 max-h-68 w-full overflow-auto rounded-ds-md border border-gray-300 bg-white text-base shadow-ds-lg focus:outline-none sm:text-sm ${open ? '':'hidden'} ${position === 'top' ? '-top-28 mb-2' : 'mt-2'}`}
        > 
        { search && 
            <div ref={searchRef} className='border-b border-gray-200 p-2'>
              <SearchBar value={searchTerm}
                         placeholder="Enter your search term"
                         onValueChange={searchHandler}/>
            </div>
        }
          <VerticalScrollBar maxHeight={dropdownDownArrowHeight} scrollHeight={'30px'}>
            {(search ? filteredData : data).map((item, index)=> {
              const value = index < valuesLen ? values[index] : item
              let disableOption = dataList.find(e => e.name === item)?.['disable']
              return (
                <li 
                  key={`${item}_${index}`}
                  onClick={disableOption ? null : () => handler(value)}
                  className={`${listItemClasses} relative mx-1 rounded-[10px] select-none ${disableOption ? `cursor-not-allowed text-gray-300` : `cursor-pointer text-gray-700 hover:bg-blue-50 hover:text-gray-900`}`}
                >
                  <span className="block truncate text-[13px] font-medium">
                    {item}
                  </span>
                </li>
              )
            })}
          </VerticalScrollBar>
        </ul>
        {error && <span className='text-ds-rose text-xs flex flex-row'><img src={red_info} style={{marginRight : '5px'}}></img>{error}</span> }
      </div>
    </>
  )
}

export default SingleSelectInput
